






































import NavButton from '@/components/shared/NavButton'
import SettingsComponent from '@/components/SettingsComponent'
import { ISnackbar, Settings } from '@/model'
import { Pages } from '@/pages'
import { mapGetters } from 'vuex'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
    NavButton: NavButton,
    SettingsComponent: SettingsComponent
  },
  computed: {
    ...mapGetters('settings', ['settings'])
  }
})
export default class SettingsView extends Vue {
  private homeRouteLink: string = Pages.HOME.routeLink
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000 }
  private settings!: Settings
  private initialSettings: Settings = {}

  created() {
    this.initialSettings = JSON.parse(JSON.stringify(this.settings))
  }

  private async save (settings: Settings) {
    await this.$store.dispatch('settings/updateSettings', settings)
    if (this.$store.state.settings.error) {
      this.snackbar.show = true
      this.snackbar.color = 'error'
      this.snackbar.text = String(this.$t('general.settingsSaveFail'))
      await this.$store.dispatch('settings/closeError')
    } else {
      this.snackbar.show = true
      this.snackbar.color = 'success'
      this.snackbar.text = String(this.$t('general.settingsSaved'))
    }
  }

  private route () {
    this.$router.push(this.homeRouteLink)
  }

  private closeSnackbar () {
    this.snackbar.show = false
    this.$store.dispatch('settings/closeError')
  }
}
